import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-date-range-popup',
  templateUrl: './date-range-popup.component.html',
  styleUrls: ['./date-range-popup.component.scss']
})
export class DateRangePopupComponent implements OnInit {

  endDate:Date | undefined;
  startDate:Date | undefined;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<DateRangePopupComponent>,
  private toastr:ToastrService) { }

  ngOnInit(): void {
  }

  applySearch(){
    if(this.endDate == undefined || this.startDate == undefined || this.endDate < this.startDate ){
      this.toastr.error("Invalid Date Range");
      return;
    }

    this.dialogRef.close({
      startDate:this.startDate,
      endDate:this.endDate
    });
  }

}
